<template>
  <div class="home container">
    <information />
    <speakerInfo />
    <section>
      <privacy />
    </section>
    <section class="mt-3">
      <b-button size="sm" variant="info" v-b-modal.modal-contract>特定商取引法に基づく表記</b-button>
    </section>
    <section class="preformSubmit" v-if="false">
      <div>上記内容に同意いただける方は「同意する」をクリックしてください。メールアドレス入力フォームへ進みます。</div>
      <div>
        <router-link to="/entry/mail" class="btn btn-lg btn-primary">同意する</router-link>
      </div>
    </section>
    <privacy-mark />
    <b-modal id="modal-contract" size="xl" title="特定商取引法に基づく表記" ok-only>
      <contract />
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
section.preformSubmit {
  text-align: center;
  margin-top: 1em;
}
</style>

<script>
import Information from "@/components/Information.vue"
import Privacy from '@/components/Privacy.vue'
import Contract from'@/components/Contract.vue'
import PrivacyMark from '@/components/PrivacyMark.vue'
import SpeakerInfo from '@/components/SpeakerInfo.vue'

export default {
  name: 'Home',
  components: {
    Information,
    Privacy,
    Contract,
    PrivacyMark,
    SpeakerInfo
  },
  mounted() {
    document.getElementById('html').scrollTop = 0
  }
}
</script>